<template>
  <div class="left-preview-slider">
    <svg @click="clickChange" v-if="this.openPreview" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
      stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-left material-icons-outlined">
      <polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>
    </svg>
    <svg @click="clickChange" v-if="!this.openPreview" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right">
      <polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>
    </svg>
  </div>
</template>

<script>


import { SAVE_LEFT_PREVIEW_SLIDER_STATUS } from '@/store/modules/keiyaku/actions'

export default {
  name: 'left-preview-slider',
  components: {},
  props: [],
  data() {
    return {
      openPreview: false
    }
  },
  mounted() {
    this.openPreview = this.getLeftPreviewSliderStatus
    this.$emit('click', this.openPreview)
  },
  computed: {
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    }
  },
  methods: {
    clickChange() {
      this.openPreview = !this.openPreview
      this.$store.dispatch(SAVE_LEFT_PREVIEW_SLIDER_STATUS, this.openPreview)
      this.$emit('click', this.openPreview)
    }
  }
}
</script>

<style lang="scss" scoped>
.left-preview-slider {
  display: flex;
  justify-content: flex-start;
  margin: 30px;
  gap: 30px;
  z-index: 1;
  background: #f8f8f8;
  border-radius: 4px;
  right: 3px;
  width: 100%;
  margin: 0px;
  bottom: 3px;
  height: 0px;
  position: relative;
  top: -50px;
  left: 30px;
   i {
     border: 1px solid #000000;
     border-radius: 4px;
   }
   svg {
     border: 1px solid #000000;
     border-radius: 4px;
   }
}

.content-area-reduced .left-preview-slider {
  width: 100%;
}
.btn-positive {
  border: 1px solid #7367F0;
}
</style>
